import React, { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';
import http from '../http';
import C from '../colors';

const SpaceAlert = inject('userStore', 'chargeStore', 'snackbarStore')(observer(({ userStore, chargeStore, snackbarStore }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!userStore.spaceLimit || !userStore.spaceUsed) return;
    if (userStore.spaceUsed >= userStore.spaceLimit) setOpen(true);
  }, [userStore.spaceUsed, userStore.spaceLimit]);

  const requestSpace = () => {
    http.post('/user/addExtraSpace').then(res => {
      if (res.status === 200) {
        userStore.addExtraSpace(5 * 1024 * 1024 * 1024);
        snackbarStore.showSnackbar('额外空间已添加');
        setOpen(false);
      }
    });
  };

  if (!open) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 1300,
      background: 'rgba(26,20,23,.45)',
      backdropFilter: 'blur(6px)', WebkitBackdropFilter: 'blur(6px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 24,
    }}>
      <div style={{
        background: C.paper, borderRadius: 14,
        border: `1px solid ${C.hair}`,
        width: '100%', maxWidth: 440,
        boxShadow: '0 20px 50px -12px rgba(0,0,0,.25)',
        padding: '28px 28px 24px',
      }}>
        <div style={{ fontFamily: C.mono, fontSize: 10, letterSpacing: 1.4, textTransform: 'uppercase', color: C.brand2, fontWeight: 600, marginBottom: 8 }}>
          Storage
        </div>
        <h3 style={{ margin: '0 0 6px', fontFamily: C.serif, fontSize: 24, fontWeight: 400, color: C.ink }}>
          空间不足
        </h3>
        <p style={{ margin: '0 0 24px', fontSize: 13, color: C.ink3 }}>
          当前存储空间已满，请升级套餐或领取额外空间。
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: userStore.extraSpace === 0 ? '1fr auto 1fr' : '1fr', gap: 12, alignItems: 'center' }}>
          <div style={{ background: '#fff', border: `1px solid ${C.hair}`, borderRadius: 10, padding: '14px 16px' }}>
            <div style={{ fontSize: 13, color: C.ink2, marginBottom: 10 }}>升级到更高的套餐</div>
            <button onClick={() => { chargeStore.openChargeDialog(); setOpen(false); }} style={{
              padding: '8px 16px', borderRadius: 8, border: 'none',
              background: C.brand, color: '#fff',
              fontFamily: C.sans, fontSize: 13, fontWeight: 500, cursor: 'pointer',
            }}>
              去升级
            </button>
          </div>

          {userStore.extraSpace === 0 && (
            <>
              <span style={{ fontSize: 12, color: C.ink3, textAlign: 'center' }}>或</span>
              <div style={{ background: '#fff', border: `1px solid ${C.hair}`, borderRadius: 10, padding: '14px 16px' }}>
                <div style={{ fontSize: 13, color: C.ink2, marginBottom: 10 }}>领取 5G 免费空间</div>
                <button onClick={requestSpace} style={{
                  padding: '8px 16px', borderRadius: 8,
                  border: `1px solid ${C.hair2}`, background: '#fff',
                  fontFamily: C.sans, fontSize: 13, cursor: 'pointer', color: C.ink,
                }}>
                  立即领取
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}));

export default SpaceAlert;
